export default {
    methods: {
        triggerCustomEvent: function(eventName, params) {
            let customEvent;
            if (typeof Event === 'function') {
                // Normal browsers :)
                var details = {
                    detail: params
                };
                customEvent = new CustomEvent(eventName, details);
            } else {
                // IE :(
                customEvent = document.createEvent('Event');
                customEvent.detail = params;
                customEvent.initEvent(eventName, true, true);
            }
            document.dispatchEvent(customEvent);
        }
    }
};
